module.exports = __webpack_public_path__ + "assets/img/lastz1.6da1aecb.png";